module.exports = __webpack_public_path__ + "static/media/SDG4.3d7c76b0.mp4";